import type { Context, Platform } from '@/app/common/starTrack/events/utils/starTrack.types.ts';
import { ampliSearchRequested } from '@/app/common/amplitude/events/ampliSearchRequested.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import type { SearchInfoData, SearchInfoDetailData } from '@/app/search/types.ts';
import type { CommonData } from '@/app/common/createCommonData.ts';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import type { StarTrack } from '@/app/common/starTrack/startrack.ts';
import { createSearchRequestedPayload } from '@/app/common/starTrack/events/searchRequested.ts';

type TrackingSearchRequestedProps = {
  starTrack: StarTrack;
  searchId: string;
  searchParams: SearchParams;
  searchInfoData: SearchInfoData;
  searchInfoDetailData: SearchInfoDetailData;
  commonData: CommonData;
  localization: Localization;
  context: Context;
  internalHotelId?: string;
  platform: Platform;
  logText: string;
  referrer?: string;
  apexPerimeterFlag: boolean;
};
export const trackingSearchRequested = ({
  starTrack,
  searchId,
  searchParams,
  searchInfoData,
  searchInfoDetailData,
  commonData,
  localization,
  context,
  internalHotelId,
  platform,
  logText,
  referrer,
  apexPerimeterFlag,
}: TrackingSearchRequestedProps) => {
  starTrack.searchRequested(
    createSearchRequestedPayload({
      searchId,
      searchParams,
      searchInfoData,
      searchInfoDetailData,
      commonData,
      localization,
      context,
      internalHotelId,
      platform,
      logText,
      referrer,
      apexPerimeterFlag,
    })
  );

  ampliSearchRequested({ searchParams, searchInfoData, searchInfoDetailData, commonData, localization });
};
